import React, { useState } from "react";
import { Col, Container, Row, Toast } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
// import banner from "../../assets/images/aboutUspage/about-us-bg.svg";
import { postData } from "../../api";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import phoneNo from '../../assets/images/contanctUspage/phone_icon -contanct.svg';
import mail from '../../assets/images/contanctUspage/mail_icon-contanct.svg';
import location from '../../assets/images/contanctUspage/location_icon-contanct.svg';


function ContactDetail() {
  const [show, setShow] = useState(false);

  return (
    <>
      <section className="contact-section py-50 mt-header pb-30">
        <Container>
          <Row className="justify-content-center mb-5">
            <Col lg={8} className="text-center">
              <div className="section_title">
                <div className="banner-badge mb-3">Get In Touch</div>
                <h1 className="banner-title" style={{ fontSize: '3rem' }}>
                  We Are Here <span className="gradient-text">For You</span>
                </h1>
                <p className="banner-desc mx-auto mt-3" style={{ fontSize: '1.1rem' }}>
                  Whether you have a question, project idea, or just want to say hi,
                  we are always here to help you build something amazing.
                </p>
              </div>
            </Col>
          </Row>

          <Row className="g-4 justify-content-center ">
            <Col lg={4} md={6}>
              <div className="contact-info-card">
                <div className="contact-icon-wrapper">
                  <img src={mail} alt="Mail Icon" className="img-fluid" style={{ width: '30px' }} />
                </div>
                <h3 className="contact-card-title">Email Us</h3>
                <div className="contact-card-text">
                  <p className="mb-1">sales@centillionsoftech.com</p>
                </div>
              </div>
            </Col>

            <Col lg={4} md={6}>
              <div className="contact-info-card">
                <div className="contact-icon-wrapper">
                  <img src={location} alt="Location Icon" className="img-fluid" style={{ width: '30px' }} />
                </div>
                <h3 className="contact-card-title">Visit Us</h3>
                <div className="contact-card-text">
                  <p className="mb-0">
                    1103, Mulberry Heights, Kaveri Sangam Road,
                    Near Shilaj Circle, Near Westside Elegance, Shilaj, Ahmedabad, Gujarat - 380059
                  </p>
                </div>
              </div>
            </Col>

            <Col lg={4} md={6}>
              <div className="contact-info-card">
                <div className="contact-icon-wrapper">
                  <img src={phoneNo} alt="Phone Icon" className="img-fluid" style={{ width: '30px' }} />
                </div>
                <h3 className="contact-card-title">Call Us</h3>
                <div className="contact-card-text">
                  <p className="mb-0 text-break">+91-8866531035</p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        <Toast
          onClose={() => setShow(false)}
          show={show}
          delay={3000}
          autohide
          className="toast position-fixed bottom-0 end-0 m-3"
          bg="success"
        >
          <Toast.Body className="text-white">
            We have received your inquiry. Our team will contact you soon.
          </Toast.Body>
        </Toast>
      </section>
    </>
  );
}

export default ContactDetail;
